import {
    Dialog,
    Portal,
    Box,
    Text,
    Flex,
    VStack,
    HStack,
    Button,
    Spinner,
} from "@chakra-ui/react";
import {
    useNavigate,
} from "react-router-dom";

import routes from "../../routes";

import {
    Bell,
    Settings,
    CreditCard,
    TriangleAlert,
    X,
} from "lucide-react";

import {
    useEffect,
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import {
    getNotifications,
    markNotificationRead,
} from "../../state/actions/notificationActions";
import getIconConfig from "./components/IconConfig";

const NotificationModal = ({
    isOpen,
    onClose,
}) => {
    const dispatch =
        useDispatch();
    const navigate =
    useNavigate();
    const {
        notifications,
        loading,
    } = useSelector(
        (state) =>
            state.notifications
    );
   
    useEffect(() => {
        if (isOpen) {
            dispatch(
                getNotifications(
                    null,
                    null,
                    1,
                    5,
)
            );
        }
    }, [
        isOpen,
        dispatch,
    ]);



    const handleNotificationClick =
        async (
            notification
        ) => {
          if (
    notification.read_status !==
    "Read"
) {
                await dispatch(
                    markNotificationRead(
                        notification.notification_id,
                    )
                );
            }
        };

    const handleMarkAllRead =
        async () => {
            for (const notification of notifications) {
               if (
    notification.read_status !==
    "Read"
){
                    await dispatch(
                        markNotificationRead(
                            notification.notification_id,
                        )
                    );
                }
            }
        };

    return (
        <Dialog.Root
            open={isOpen}
            onOpenChange={(
                e
            ) => {
                if (
                    !e.open
                ) {
                    onClose();
                }
            }}
        >
            <Portal>
                <Dialog.Backdrop
                    bg="blackAlpha.500"
                    backdropFilter="blur(4px)"
                />

                <Dialog.Positioner>
                <Dialog.Content
                    w={{
                        base: "calc(100vw - 32px)",
                        md: "720px",
                    }}
                    maxW="720px"
                    borderRadius="14px"
                    overflow="hidden"
                >
                        <Dialog.Header
                            px={6}
                            py={5}
                            borderBottom="1px solid"
                            borderColor="gray.200"
                        >
                            <Flex
                                  direction={{
        base: "column",
        md: "row",
    }}
    justify="space-between"
    align={{
        base: "stretch",
        md: "center",
    }}
    w="100%"
    gap={{
        base: 3,
        md: 0,
    }}
                            >
                                <HStack gap={3}>
                                    <Bell
                                        size={
                                            18
                                        }
                                        color="#2453FF"
                                    />

                                    <Text
                                        fontSize="xl"
                                        fontWeight="700"
                                    >
                                        Notifications
                                    </Text>
                                </HStack>

                                <HStack   gap={6}
    justify={{
        base: "space-between",
        md: "flex-end",
    }}
    w={{
        base: "100%",
        md: "auto",
    }}>
                                    {notifications?.length >
                                        0 && (
                                            <Text
                                                color="#2453FF"
                                                fontSize="sm"
                                                fontWeight="600"
                                                cursor="pointer"
                                                onClick={
                                                    handleMarkAllRead
                                                }
                                            >
                                                Mark
                                                all
                                                as
                                                read
                                            </Text>
                                        )}

                                    <Box
                                        cursor="pointer"
                                        onClick={
                                            onClose
                                        }
                                    >
                                        <X
                                            size={
                                                18
                                            }
                                        />
                                    </Box>
                                </HStack>
                            </Flex>
                        </Dialog.Header>

                        <Dialog.Body p={0}>
                            {loading ? (
                                <Flex
                                    p={
                                        10
                                    }
                                    justify="center"
                                    align="center"
                                >
                                    <Spinner  color="#2453FF"/>

                                    <Text ml={3}>
                                        Loading
                                        notifications...
                                    </Text>
                                </Flex>
                            ) : notifications?.length ===
                                0 ? (
                                <Flex
                                    p={
                                        10
                                    }
                                    justify="center"
                                >
                                    <Text color="gray.500">
                                        No
                                        notifications
                                        found
                                    </Text>
                                </Flex>
                            ) : (
                                <VStack
                                    gap={
                                        0
                                    }
                                    align="stretch"
                                >
                                    {notifications?.map(
                                        (
                                            notification
                                        ) => {
                                            const config =
                                                getIconConfig(
                                                    notification
                                                );

                                            const Icon =
                                                config.icon;

                                            return (
                                                <Flex
                                                    key={
                                                        notification.notification_id
                                                    }
                                                    p={
                                                        6
                                                    }
                                                    gap={
                                                        4
                                                    }
                                                    cursor="pointer"
                                                    onClick={() =>
                                                        handleNotificationClick(
                                                            notification
                                                        )
                                                    }
                                                   bg={
                                                    notification.read_status ===
                                                    "Read"
                                                        ? "white"
                                                        : "#F8FAFC"
                                                }
                                                    borderBottom="1px solid"
                                                    borderColor="gray.100"
                                                >
                                                    <Flex
                                                        w="44px"
                                                        h="44px"
                                                        borderRadius="12px"
                                                        bg={
                                                            config.bg
                                                        }
                                                        align="center"
                                                        justify="center"
                                                        flexShrink={
                                                            0
                                                        }
                                                    >
                                                        <Icon
                                                            size={
                                                                20
                                                            }
                                                            color={
                                                                config.color
                                                            }
                                                        />
                                                    </Flex>

                                                    <Box flex="1">
                                                        <Flex
                                                            justify="space-between"
                                                            align="start"
                                                            mb={
                                                                2
                                                            }
                                                        >
                                                            <Text
                                                                fontSize="xs"
                                                                fontWeight="700"
                                                                color={
                                                                    config.color
                                                                }
                                                                letterSpacing="1px"
                                                            >
                                                                {notification.category ||
                                                                    notification.notification_type ||
                                                                    "SYSTEM"}
                                                            </Text>

                                                            <Text
                                                                color="gray.500"
                                                                fontSize="sm"
                                                            >
                                                                {notification.created_at ||
                                                                    ""}
                                                            </Text>
                                                        </Flex>

                                                        <Text
                                                            fontWeight="700"
                                                            mb={
                                                                1
                                                            }
                                                        >
                                                            {notification.title}
                                                        </Text>

                                                        <Text
                                                            color="gray.600"
                                                            fontSize="sm"
                                                            lineHeight="1.7"
                                                        >
                                                            {notification.message ||
                                                                notification.description}
                                                        </Text>
                                                    </Box>
                                                </Flex>
                                            );
                                        }
                                    )}
                                </VStack>
                            )}
                        </Dialog.Body>

                        <Dialog.Footer
                            justifyContent="center"
                            py={5}
                            bg="#F8FAFC"
                            borderTop="1px solid"
                            borderColor="gray.200"
                        >
                            <Button
                                variant="ghost"
                                color="#2453FF"
                                fontWeight="700"
                                onClick={() => {
                                    onClose();

                                    navigate(
                                        routes.notifications
                                    );
                                }}
                            >
                                View All Notifications
                            </Button>
                        </Dialog.Footer>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};

export default NotificationModal;